// Turns the number into a string with a seperator and 2 decimal places
export function prettifyNumber(value: number) {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export function formatToPrice(value: number, currency?: string) {
  return currencyToSymbol(currency) + ' ' + prettifyNumber(value)
}

export function currencyToSymbol(currency?: string) {
  switch (currency) {
    case 'PHP':
      return '‎₱'
    case 'MYR':
      return 'RM'
    case 'IDR':
      return 'Rp'
    case 'SGD':
    default:
      return 'S$'
  }
}
